<div *ngFor="let product of getProductsFilteredByParentId(); let i = index"
     class="product-element mb-3 border-top"
     [class.product-element--not-first-level]="!isTopLevelProduct"
     [class.mb-0]="!isTopLevelProduct"
     [class.pb-0]="isProductExpanded(product.productPartId)"
     [class.product-element--active]="product.isSelected"
     [class.product-element--transparent]="product.isGhost">
  <div class="ml-20" [style]="{paddingLeft: product.level * 25 + 'px'}">
    <div class="d-flex justify-content-between mb-20">
      <div class="d-flex align-items-center">
        <div class="blinker blinker--green mr-2" *ngIf="!isTopLevelProduct && !product.isGhost && product.isBillOfMaterialsConfirmed" tooltipStr="Odobreno od razvoja"></div>
        <div class="blinker blinker--orange mr-2" *ngIf="!isTopLevelProduct && product.areOperationsConfirmed" tooltipStr="Odobreno od tehnologije"></div>
        <div class="mr-10 font-16 text-gray bold">{{fullParentIndex ? fullParentIndex + '.' : ''}}{{i + 1}}</div>
        <div class="d-flex" *ngIf="product.level > 0">
          <app-tag class="mr-2" [sector]="product.sector?.name" [isActive]="true"></app-tag>
        </div>
        <div class="font-16 mr-20 pointer" [class.bold]="product.productClass !== 'importedMaterial'" [class.pointer]="(product.productClass === 'semiProduct' || product.productClass === 'finishedProduct') && product.level > 0" (click)="goToProductDevelopmentPage(product)">{{ product.name }}</div>
        <i *ngIf="isNotMaterial(product)" class="fa fa-folder-tree"></i>
      </div>
      <div class="mr-10 pointer">
        <!-- <i class="fa fa-plus ml-3" *ngIf="(product.productClass === 'semiProduct' || product.productClass === 'finishedProduct') && product.level > 0 && permissionHelper.isEnabledMethod('requestSemiProduct')" (click)="onAddProductElement(product)" ngxClickStopPropagation></i> -->
        <i class="fa fa-edit ml-3" 
           *ngIf="product.level > 0 && permissionHelper.isEnabledMethod('editSemiProduct') && !parentProduct?.isLocked && !parentProduct?.isBillOfMaterialsConfirmed" 
           (click)="onEditProductElement(product)"
           ngxClickStopPropagation></i>
        <i class="fa fa-trash ml-3" 
           *ngIf="permissionHelper.isEnabledMethod('deleteRequestedSemiProduct') && !parentProduct?.isLocked && !parentProduct?.isBillOfMaterialsConfirmed" 
           (click)="onDeleteProductElement(product)"
           ngxClickStopPropagation></i>
      </div>
    </div>
    <div class="d-flex justify-content-between pb-20 mr-20">
      <div class="w-50 d-flex justify-content-between">
        <div *ngIf="product.level > 0">
          <div class="bold">Količina</div>
          <div>{{ product.quantity || '/' | digitFormat }}</div>
        </div>
        <div>
          <div class="bold">Jedinica mere</div>
          <div>{{ product.unit || '/' }}</div>
        </div>
      </div>
      <div class="text-right" *ngIf="hasChildren(product)" (click)="getChildElements(product)" ngxClickStopPropagation>
        <div>
          <i class="pointer font-20" [ngClass]="isProductExpanded(product.productPartId) ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
        </div>
      </div>
    </div>
    <div *ngIf="product.comment">
      <div class="bold">Komentar:</div>
      <div class="mb-5">{{ product.comment }}</div>
    </div>
  </div>

  <!--Recursive component-->
  <app-product-segment *ngIf="isProductExpanded(product.productPartId)"
                       [productElements]="productElements"
                       [parentId]="product.productPartId"
                       [fullParentIndex]="(fullParentIndex ? (fullParentIndex + '.') : '') + (i + 1)"
                       [parentProduct]="parentProduct"
                       (productElementEdited)="onEditProductElement($event)"
                       (productElementDeleted)="onDeleteProductElement($event)"></app-product-segment>
</div>
